import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Checkbox, FormControlLabel } from '@material-ui/core';
import { Typography } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(5.5),
    },
    label: {
      paddingLeft: theme.spacing(1),
    },
    formControl: {
      marginLeft: theme.spacing(0),
      '& .MuiFormControlLabel-label': {
        ...theme.typography.body1,
        color: theme.palette.text.primary,
      },
    },
  };
});

const TTSAutoFitControl = ({
  ttsZoomPreference,
  onTTSZoomPreferenceChange,
}) => {
  const classes = useStyles();

  const handleChange = (event) => {
    onTTSZoomPreferenceChange(event.target.checked ? 'fit' : 'leaveAsIs');
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.label} id="auto-fit-control">
        Appearance
      </Typography>
      <FormControlLabel
        className={classes.formControl}
        control={
          <Checkbox
            checked={ttsZoomPreference === 'fit'}
            onChange={handleChange}
            name="autoFitToScreen"
            color="primary"
          />
        }
        label="Auto-Fit to Screen"
      />
    </div>
  );
};

TTSAutoFitControl.propTypes = {
  ttsZoomPreference: PropTypes.string,
  onTTSZoomPreferenceChange: PropTypes.func.isRequired,
};

export default TTSAutoFitControl;
